/**
 * Конверсии Google Ads через GTM dataLayer.
 * Теги конверсий настраиваются в контейнере GTM (триггер: ads_conversion).
 */
export const gtag_report_conversion = (id, user_data = null) => {
  if (typeof window === 'undefined') return false

  window.dataLayer = window.dataLayer || []

  const payload = {
    event: 'ads_conversion',
    send_to: id,
    value: 1.0,
    currency: 'USD',
  }

  if (user_data) {
    payload.user_data = user_data
  }

  window.dataLayer.push(payload)
  return false
}
